export default [{
  path: '/position',
  name: 'position',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/position/index')
}]
